(function () {
  var SWIPER_SELECTORS = [
    '.swiper.isbest-seller',
    '.swiper.ismulti-seller',
    '.swiper.is-blog',
    '.swiper.ismultis-seller',
    '.swiper.islearn',
    '.swiper.is-what',
    '.swiper.iscardimages',
    '.swiper.is-featured'
  ];

  function pageHasSwiper() {
    return SWIPER_SELECTORS.some(function (selector) {
      return document.querySelector(selector);
    });
  }

  function initSwipers() {
    if (typeof Swiper === 'undefined') {
      return false;
    }

    if (document.querySelector('.swiper.isbest-seller') && !document.querySelector('.swiper.isbest-seller').swiper) {
      new Swiper('.swiper.isbest-seller', {
        slidesPerView: 4,
        spaceBetween: 20,
        breakpoints: {
          320: { slidesPerView: 1.3, spaceBetween: 10 },
          499: { slidesPerView: 1.3, spaceBetween: 10 },
          768: { slidesPerView: 3, spaceBetween: 20 },
          1080: { slidesPerView: 3, spaceBetween: 20 },
          1440: { slidesPerView: 4, spaceBetween: 20 }
        }
      });
    }

    if (document.querySelector('.swiper.ismulti-seller') && !document.querySelector('.swiper.ismulti-seller').swiper) {
      new Swiper('.swiper.ismulti-seller', {
        slidesPerView: 4,
        spaceBetween: 20,
        breakpoints: {
          320: { slidesPerView: 1.3, spaceBetween: 10 },
          499: { slidesPerView: 1.3, spaceBetween: 10 },
          768: { slidesPerView: 3.125, spaceBetween: 20 },
          1080: { slidesPerView: 3.5, spaceBetween: 20 },
          1440: { slidesPerView: 4, spaceBetween: 20 }
        }
      });
    }

    if (document.querySelector('.swiper.is-blog') && !document.querySelector('.swiper.is-blog').swiper) {
      new Swiper('.swiper.is-blog', {
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination-blog',
          clickable: true
        },
        breakpoints: {
          320: { slidesPerView: 1.3, spaceBetween: 10 },
          499: { slidesPerView: 1.3, spaceBetween: 10 },
          768: { slidesPerView: 2.125, spaceBetween: 20 },
          1080: { slidesPerView: 3, spaceBetween: 20 },
          1440: { slidesPerView: 3, spaceBetween: 30 }
        }
      });
    }

    if (document.querySelector('.swiper.ismultis-seller') && !document.querySelector('.swiper.ismultis-seller').swiper) {
      new Swiper('.swiper.ismultis-seller', {
        slidesPerView: 2,
        spaceBetween: 20,
        breakpoints: {
          320: { slidesPerView: 1, spaceBetween: 10 },
          499: { slidesPerView: 1.25, spaceBetween: 10 },
          768: { slidesPerView: 2, spaceBetween: 20 },
          1440: { slidesPerView: 2, spaceBetween: 20 }
        }
      });
    }

    if (document.querySelector('.swiper.islearn') && !document.querySelector('.swiper.islearn').swiper) {
      new Swiper('.swiper.islearn', {
        slidesPerView: 4,
        spaceBetween: 20,
        breakpoints: {
          320: { slidesPerView: 1.3, spaceBetween: 10 },
          499: { slidesPerView: 1.3, spaceBetween: 10 },
          768: { slidesPerView: 2.5, spaceBetween: 20 },
          1080: { slidesPerView: 3.5, spaceBetween: 20 },
          1440: { slidesPerView: 4, spaceBetween: 20 }
        }
      });
    }

    if (document.querySelector('.swiper.is-what') && !document.querySelector('.swiper.is-what').swiper) {
      new Swiper('.swiper.is-what', {
        slidesPerView: 4,
        spaceBetween: 20,
        navigation: {
          nextEl: '.arrow.next1',
          prevEl: '.arrow.prev1'
        },
        pagination: {
          el: '.swiper-pagination-fraction',
          type: 'fraction'
        },
        scrollbar: {
          el: '.swiper-pagination-slider'
        },
        breakpoints: {
          320: { slidesPerView: 1, spaceBetween: 10 },
          499: { slidesPerView: 1, spaceBetween: 10 },
          768: { slidesPerView: 3.125, spaceBetween: 20 },
          1080: { slidesPerView: 3.5, spaceBetween: 20 },
          1440: { slidesPerView: 4, spaceBetween: 20 }
        }
      });
    }

    if (document.querySelector('.swiper.iscardimages') && !document.querySelector('.swiper.iscardimages').swiper) {
      new Swiper('.swiper.iscardimages', {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination-fraction',
          type: 'fraction'
        },
        scrollbar: {
          el: '.swiper-pagination-slider'
        },
        breakpoints: {
          320: { slidesPerView: 1, spaceBetween: 10 },
          499: { slidesPerView: 1, spaceBetween: 10 },
          768: { slidesPerView: 3.125, spaceBetween: 20 },
          1080: { slidesPerView: 3.5, spaceBetween: 20 },
          1440: { slidesPerView: 4, spaceBetween: 20 }
        }
      });
    }

    if (document.querySelector('.swiper.is-featured') && !document.querySelector('.swiper.is-featured').swiper) {
      new Swiper('.swiper.is-featured', {
        slidesPerView: 4,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination-featured',
          clickable: true
        },
        breakpoints: {
          320: { slidesPerView: 1.125, spaceBetween: 10 },
          499: { slidesPerView: 2.125, spaceBetween: 10 },
          768: { slidesPerView: 3.125, spaceBetween: 20 },
          1080: { slidesPerView: 3.5, spaceBetween: 20 },
          1440: { slidesPerView: 4, spaceBetween: 20 }
        }
      });
    }

    return true;
  }

  if (!pageHasSwiper()) {
    return;
  }

  var attempts = 0;
  var maxAttempts = 50;

  function schedule() {
    if (initSwipers()) {
      return;
    }

    attempts += 1;
    if (attempts < maxAttempts) {
      window.setTimeout(schedule, 50);
    }
  }

  function runWhenIdle() {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(schedule, { timeout: 2500 });
    } else {
      window.addEventListener('load', schedule, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runWhenIdle, { once: true });
  } else {
    runWhenIdle();
  }

  window.FP_rerunSwipers = initSwipers;
})();
